import clsx, { type ClassValue } from 'clsx';

/** Junta classes condicionais. Fino wrapper sobre clsx para uso uniforme. */
export function cn(...values: ClassValue[]): string {
  return clsx(values);
}
